import { selectorIcon } from "../../../assets/icons";
import { useState, useEffect } from "react";

const ASC = "asc";
const DESC = "desc";

const CustomTableHeader = ({
  column,
  shouldShowSaveButton,
  displayName,
  setSort,
}) => {
  const [sortOrder, setSortOrder] = useState();

  useEffect(() => {
    column.addEventListener("sortChanged", setSortOrder);
  }, [column]);

  useEffect(() => {
    if (shouldShowSaveButton) setSort(null);
  }, [shouldShowSaveButton, setSort]);

  return (
    <div className="h-full w-full flex items-center pr-4">
      <span className="truncate ...">{displayName}</span>
      {!shouldShowSaveButton && (
        <img
          src={selectorIcon}
          alt="selector"
          className="absolute top-4 right-2.5 w-4 h-4 cursor-pointer"
          onClick={(event) => {
            const sortingOrder = sortOrder === ASC ? DESC : ASC;
            setSort(sortingOrder, event.shiftKey);
            setSortOrder(sortingOrder);
          }}
        />
      )}
    </div>
  );
};

export default CustomTableHeader;
